import { t } from 'i18next';
import React from 'react';
import Heading from '../atoms/Heading';

const styles = {
  link: {
    justifyContent: 'flex-end',
  },
};

interface Props {
  liveEventsCount?: { count: number };
}

const InPlayHeadings = ({ liveEventsCount }: Props) => {
  return (
    <Heading to='../in-play'>
      <Heading.Title>{t('live')}</Heading.Title>
      <Heading.Link sx={styles.link}>{t('nEvents', { count: liveEventsCount?.count ?? 0 })}</Heading.Link>
    </Heading>
  );
};

export default InPlayHeadings;
